export const NEW_YEAR_TITLE = 'Прежде чем продолжим';
export const NEW_YEAR_MESSAGES =
  'Срок готовности отчёта: ~3 рабочих дня. Если вы оплатите заявку на отчёт в новогодние выходные — с 30 декабря 2023 года по 8 января 2024 года — мы начнём работать с ней 9 января 2024 года.';
